import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20illustration%20style%20background%2C%20abstract%20artistic%20composition%20with%20flowing%20ink%20brush%20strokes%20in%20warm%20coral%20and%20dark%20navy%20tones%2C%20dynamic%20energy%20lines%2C%20manga%20speed%20lines%20effect%2C%20cinematic%20lighting%2C%20atmospheric%20depth%2C%20dramatic%20contrast%2C%20no%20text%20no%20characters&width=1600&height=800&seq=hero-bg-manhwa-01&orientation=landscape"
        alt="韩漫漫画网站背景"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50" />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/60 via-transparent to-background-50/60" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <p className="inline-block px-4 py-1.5 text-sm rounded-full bg-primary-500/20 text-primary-400 border border-primary-500/30 mb-6 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>
              全网最全韩漫资源 · 每日更新
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight">
              韩漫在线观看
              <br />
              <span className="text-primary-500">免费韩国漫画</span> 下拉式阅读
            </h1>
            <p className="mt-5 text-foreground-400 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0">
              牢记此漫画网址，即可在韩漫漫画网站享受韩漫在线观看与免费韩国漫画下拉式阅读，一站式满足您的所有观看需求。海量韩漫资源，每日更新，精彩不容错过。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-300 whitespace-nowrap shadow-[0_0_30px_rgba(234,88,12,0.3)]"
              >
                <i className="ri-book-open-line mr-2"></i>
                开始阅读
              </Link>
              <Link
                to="/category/romance"
                className="px-8 py-3 rounded-lg border border-foreground-300/30 text-foreground-200 hover:text-foreground-50 hover:border-foreground-50/50 font-semibold text-sm transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-heart-line mr-2"></i>
                恋爱漫画
              </Link>
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-5 justify-center lg:justify-start">
              {[
                { value: "5000+", label: "漫画资源" },
                { value: "99%", label: "满意度" },
                { value: "每日更新", label: "更新频率" },
                { value: "免费阅读", label: "阅读模式" },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-4 flex-shrink-0">
            <div className="flex flex-col gap-4">
              <div className="w-[160px] h-[220px] rounded-lg overflow-hidden bg-background-200 border border-background-300/50 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20manga%20cover%20art%2C%20beautiful%20couple%20embracing%20in%20snowy%20Seoul%20street%2C%20warm%20romantic%20atmosphere%2C%20pink%20and%20white%20color%20tones%2C%20manhwa%20style%2C%20clean%20composition%2C%20simple%20winter%20background&width=320&height=440&seq=hero-thumb-1&orientation=portrait"
                  alt="韩漫精选"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-[160px] h-[220px] rounded-lg overflow-hidden bg-background-200 border border-background-300/50 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20manga%20cover%2C%20epic%20sword%20warrior%20with%20glowing%20blade%20against%20storm%20sky%2C%20dramatic%20lighting%2C%20red%20and%20dark%20blue%20contrast%2C%20manhwa%20style%2C%20dynamic%20pose%2C%20simple%20stormy%20background&width=320&height=440&seq=hero-thumb-2&orientation=portrait"
                  alt="韩漫热门"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="flex flex-col gap-4 -mt-8">
              <div className="w-[160px] h-[220px] rounded-lg overflow-hidden bg-background-200 border border-background-300/50 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20manga%20cover%2C%20young%20woman%20looking%20at%20starry%20night%20sky%20from%20rooftop%2C%20melancholic%20beautiful%20atmosphere%2C%20purple%20and%20gold%20tones%2C%20manhwa%20style%2C%20simple%20night%20sky%20background&width=320&height=440&seq=hero-thumb-3&orientation=portrait"
                  alt="韩漫推荐"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-[160px] h-[220px] rounded-lg overflow-hidden bg-background-200 border border-background-300/50 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20slice%20of%20life%20manga%20cover%2C%20cute%20friends%20laughing%20together%20in%20cafe%2C%20bright%20yellow%20and%20mint%20green%20pastel%20colors%2C%20manhwa%20style%2C%20cheerful%20vibe%2C%20simple%20cafe%20interior%20background&width=320&height=440&seq=hero-thumb-4&orientation=portrait"
                  alt="韩漫人气"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent pointer-events-none" />
    </section>
  );
}